// A Shopify custom Web Pixel can later subscribe to Shopify.analytics.publish
// events from trackUpsellEvent and forward to Meta CAPI / TikTok Events API.

const UPSELL_SOURCE = {
  FBW: 'frequently_bought_with',
  EXCLUSIVE: 'exclusive_panel',
};

const upsellModuleViewedSession = {
  [UPSELL_SOURCE.FBW]: false,
  [UPSELL_SOURCE.EXCLUSIVE]: false,
};

let upsellModuleViewObservers = [];

function trackUpsellEvent(eventName, properties) {
  const payload = { event: eventName, ...properties, timestamp: Date.now() };
  try {
    if (window.dataLayer) window.dataLayer.push(payload);
  } catch (e) {
    /* sink unavailable */
  }
  try {
    if (window._learnq) window._learnq.push(['track', eventName, properties]);
  } catch (e) {
    /* sink unavailable */
  }
  try {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, properties);
    }
  } catch (e) {
    /* sink unavailable */
  }
}

function getUpsellTrackingContext() {
  return {
    customer_status: document.body?.classList?.contains('logged-in') ? 'logged_in' : 'guest',
    market: document.body?.dataset?.market || '',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
  };
}

function calcUpsellDiscountPct(priceCents, compareAtCents) {
  const price = Number(priceCents) || 0;
  const compareAt = Number(compareAtCents) || 0;
  if (!compareAt || compareAt <= price) return 0;
  return Math.round(((compareAt - price) * 100) / compareAt);
}

function getCartTotalValue(cart) {
  return typeof cart?.total_price === 'number' ? cart.total_price : null;
}

function buildUpsellPayload(source, itemEl, variantData = {}, extra = {}) {
  const price = Number(variantData.price) || 0;
  const compareAt = Number(variantData.compare_at_price) || 0;
  return {
    source,
    product_id: Number(itemEl?.dataset?.productId) || null,
    variant_id: Number(variantData.variant_id) || Number(itemEl?.dataset?.variantId) || null,
    product_title: itemEl?.dataset?.productTitle || '',
    variant_title: variantData.variant_title || '',
    price,
    compare_at_price: compareAt,
    discount_pct: calcUpsellDiscountPct(price, compareAt),
    position: Number(itemEl?.dataset?.position) || 0,
    ...getUpsellTrackingContext(),
    ...extra,
  };
}

function getFbUpsellVariantData(selectEl, itemEl) {
  const variantId = Number(selectEl?.value || itemEl?.dataset?.variantId || 0);
  if (!variantId) return null;

  let variants = [];
  try {
    if (selectEl && !selectEl._upsellVariantsCache) {
      const raw = selectEl.getAttribute('data-variants') || '[]';
      selectEl._upsellVariantsCache = JSON.parse(raw);
    }
    variants = Array.isArray(selectEl?._upsellVariantsCache) ? selectEl._upsellVariantsCache : [];
  } catch (e) {
    variants = [];
  }

  const variant = variants.find((v) => Number(v?.id) === variantId);
  if (variant) {
    return {
      variant_id: variantId,
      variant_title: variant.title || variant.public_title || '',
      price: Number(variant.price) || 0,
      compare_at_price: Number(variant.compare_at_price) || 0,
    };
  }

  return {
    variant_id: variantId,
    variant_title: '',
    price: 0,
    compare_at_price: 0,
  };
}

function getExclusiveUpsellVariantData(selectEl, itemEl, btn) {
  const variantId = Number(btn?.dataset?.variantId || selectEl?.value || 0);
  if (!variantId) return null;

  if (selectEl) {
    const option = selectEl.options?.[selectEl.selectedIndex];
    if (option?.value) {
      return {
        variant_id: variantId,
        variant_title: option.textContent?.trim() || '',
        price: Number(option.dataset.price) || 0,
        compare_at_price: Number(option.dataset.compareAt) || 0,
      };
    }
  }

  return {
    variant_id: variantId,
    variant_title: '',
    price: 0,
    compare_at_price: 0,
  };
}

function resetUpsellModuleViewedSession() {
  upsellModuleViewedSession[UPSELL_SOURCE.FBW] = false;
  upsellModuleViewedSession[UPSELL_SOURCE.EXCLUSIVE] = false;
  upsellModuleViewObservers.forEach((observer) => {
    try {
      observer.disconnect();
    } catch (e) {
      /* ignore */
    }
  });
  upsellModuleViewObservers = [];
}

function trackUpsellModuleViewed(source) {
  if (upsellModuleViewedSession[source]) return;
  upsellModuleViewedSession[source] = true;
  trackUpsellEvent('upsell_module_viewed', {
    source,
    ...getUpsellTrackingContext(),
  });
}

function observeUpsellModuleForView(element, source) {
  if (!element || upsellModuleViewedSession[source]) return;

  const root = document.getElementById('CartDrawer') || null;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        trackUpsellModuleViewed(source);
        try {
          observer.disconnect();
        } catch (e) {
          /* ignore */
        }
      });
    },
    { root, threshold: 0.2 },
  );

  observer.observe(element);
  upsellModuleViewObservers.push(observer);
}

function initUpsellModuleViewTrackingOnDrawerOpen() {
  const fbwRoot =
    document.querySelector('cart-drawer-upsell .cart-drawer-upsell[data-upsell-section]') ||
    document.querySelector('cart-drawer-upsell .cart-drawer-upsell');
  const exclusiveRoot = document.getElementById('CartDrawer-Exclusive');

  if (fbwRoot && !fbwRoot.classList.contains('is-closed')) {
    observeUpsellModuleForView(fbwRoot, UPSELL_SOURCE.FBW);
  }
  if (exclusiveRoot && !exclusiveRoot.classList.contains('is-closed')) {
    observeUpsellModuleForView(exclusiveRoot, UPSELL_SOURCE.EXCLUSIVE);
  }
}

function bindFrequentlyBoughtWithUpsellTracking(sectionRoot, swiperInstance) {
  if (!sectionRoot || sectionRoot.dataset.upsellTrackingBound === 'true') return;
  sectionRoot.dataset.upsellTrackingBound = 'true';

  observeUpsellModuleForView(sectionRoot, UPSELL_SOURCE.FBW);

  sectionRoot.addEventListener('click', (event) => {
    const link = event.target.closest('.cart-drawer-upsell-item__title, .cart-drawer-upsell-item__media');
    if (!link) return;
    const itemEl = link.closest('.cart-drawer-upsell-item');
    if (!itemEl) return;
    const selectEl = itemEl.querySelector('[data-upsell-variant-select]');
    const variantData = getFbUpsellVariantData(selectEl, itemEl);
    if (!variantData) return;
    trackUpsellEvent(
      'upsell_product_clicked',
      buildUpsellPayload(UPSELL_SOURCE.FBW, itemEl, variantData),
    );
  });

  const trackCarouselNav = (direction) => {
    trackUpsellEvent('upsell_carousel_navigated', {
      source: UPSELL_SOURCE.FBW,
      direction,
      ...getUpsellTrackingContext(),
    });
  };

  const prevEl = sectionRoot.closest('cart-drawer-upsell')?.querySelector('[data-upsell-prev]') ||
    sectionRoot.querySelector('[data-upsell-prev]');
  const nextEl = sectionRoot.closest('cart-drawer-upsell')?.querySelector('[data-upsell-next]') ||
    sectionRoot.querySelector('[data-upsell-next]');
  prevEl?.addEventListener('click', () => trackCarouselNav('prev'));
  nextEl?.addEventListener('click', () => trackCarouselNav('next'));

  if (swiperInstance && typeof swiperInstance.on === 'function') {
    swiperInstance.on('slideNextTransitionStart', () => trackCarouselNav('next'));
    swiperInstance.on('slidePrevTransitionStart', () => trackCarouselNav('prev'));
  }
}

function bindExclusivePanelUpsellTracking(panel) {
  if (!panel || panel.dataset.upsellTrackingBound === 'true') return;
  panel.dataset.upsellTrackingBound = 'true';

  observeUpsellModuleForView(panel, UPSELL_SOURCE.EXCLUSIVE);

  panel.addEventListener('click', (event) => {
    const link = event.target.closest('.cart-drawer-exclusive-item__title, .cart-drawer-exclusive-item__media');
    if (!link) return;
    const itemEl = link.closest('.cart-drawer-exclusive-item');
    if (!itemEl) return;
    const selectEl = itemEl.querySelector('[data-exclusive-variant-select]');
    const addBtn = itemEl.querySelector('[data-exclusive-add]');
    const variantData = getExclusiveUpsellVariantData(selectEl, itemEl, addBtn);
    if (!variantData) return;
    trackUpsellEvent(
      'upsell_product_clicked',
      buildUpsellPayload(UPSELL_SOURCE.EXCLUSIVE, itemEl, variantData),
    );
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.classList.remove('hidden');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      // On the cart page, don't open the drawer — navigate to /cart normally
      if (window.location.pathname === '/cart') return;
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        if (window.location.pathname === '/cart') return;
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy, options = {}) {
    // Never open the drawer when already on the cart page
    if (window.location.pathname === '/cart') return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // Adds that originate from inside the drawer itself (free gift claim, "frequently
    // bought with" upsell, the Exclusive panel's own add-to-cart) shouldn't reset the
    // Exclusive panel's open/closed state — only a "fresh" drawer open (e.g. from a PDP
    // add-to-cart) re-derives it from the dismissal flag.
    if (!options.skipExclusivePanel) {
      const exclusivePanel = this.querySelector('#CartDrawer-Exclusive');
      if (exclusivePanel) {
        try {
          const dismissed = sessionStorage.getItem('exclusive_panel_dismissed');
          exclusivePanel.classList.toggle('is-closed', dismissed === '1');
        } catch (e) {
          exclusivePanel.classList.remove('is-closed');
        }
      }
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('drawer-open');
    initUpsellModuleViewTrackingOnDrawerOpen();

    // If a quick-add happened since the drawer was last rendered, its line items are
    // stale (cart-drawer is no longer rendered on the add request, to keep quick-add
    // fast). The drawer is already visually open, so refresh its contents now behind a
    // brief loading state instead of blocking the add.
    if (window.cartDrawerStale) {
      this.refreshStaleContents();
    }
  }

  async refreshStaleContents() {
    // Clear first so an add that happens during this fetch re-marks the drawer stale.
    window.cartDrawerStale = false;
    // Snapshot the render generation so a fresher in-drawer render (e.g. an Exclusive
    // or gift add) that lands while we're fetching is not clobbered by our older HTML.
    const renderSeq = window.__cartDrawerRenderSeq || 0;
    try {
      if (typeof setCartDrawerLoading === 'function') setCartDrawerLoading(true);
      const [data, cart] = await Promise.all([
        fetch('/?sections=cart-drawer,cart-icon-bubble', { method: 'GET' }).then((r) => r.json()),
        fetch('/cart.js', { method: 'GET' }).then((r) => r.json()),
      ]);
      // Superseded by a newer drawer render while we were fetching — bail out so we
      // don't overwrite fresher content (or cart state) with our stale response.
      if ((window.__cartDrawerRenderSeq || 0) !== renderSeq) return;
      if (typeof window.handleCartUpdated === 'function') {
        window.handleCartUpdated(cart);
      } else {
        window.cartJSON = cart;
      }
      this.renderContents({ sections: data }, false);
    } catch (e) {
      console.error('Cart drawer stale refresh failed', e);
      window.cartDrawerStale = true; // leave stale so it retries on next open
    } finally {
      if (typeof setCartDrawerLoading === 'function') setCartDrawerLoading(false);
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('drawer-open');
    resetUpsellModuleViewedSession();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, open = true, options = {}) {
    // Every drawer render bumps this generation counter so an in-flight stale refresh
    // can detect it was superseded and avoid clobbering fresher content.
    window.__cartDrawerRenderSeq = (window.__cartDrawerRenderSeq || 0) + 1;
    this.productId = parsedState.id;
    const parsedDocs = {};
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const sectionId = section.id;
      const html = parsedState.sections[sectionId];
      if (!html) return;
      if (!parsedDocs[sectionId]) {
        parsedDocs[sectionId] = new DOMParser().parseFromString(html, 'text/html');
      }
      const doc = parsedDocs[sectionId];
      const source = section.selector ? doc.querySelector(section.selector) : doc.querySelector('.shopify-section');
      if (source) replaceKeepingRedo(sectionElement, source.innerHTML);
    });

    try {
      const protectionId = getProtectionProductIdFromDrawer();
      const sourceCart =
        (parsedState && typeof parsedState.item_count === 'number' && parsedState) ||
        (window.cartJSON && typeof window.cartJSON === 'object' ? window.cartJSON : null);
      let isEmpty = isCartEffectivelyEmpty(sourceCart, protectionId);

      // If we just added an item (indicated by id, key, or items array in response), it's definitely not empty
      if (parsedState && (parsedState.id || parsedState.key || (Array.isArray(parsedState.items) && parsedState.items.length))) {
        isEmpty = false;
      }

      this.classList.toggle('is-empty', isEmpty);
      const itemsEl = document.getElementById('CartDrawer-Items');
      if (itemsEl) {
        itemsEl.classList.toggle('is-empty', isEmpty);
      }
    } catch (e) {
      console.error('Failed to sync cart drawer empty state', e);
    }

    // Adds still in flight must survive the wholesale item-list replace above.
    this.reapplyOptimistic();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (open) this.open(undefined, options);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section');
    return node ? node.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer-Items',
      },
      {
        id: 'cart-drawer',
        selector: '#Drawer-Footer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  // ── Optimistic add-to-cart ─────────────────────────────────────────────────
  // The cart backend takes ~1s+ (Plus Scripts/bundles), so product-form.js calls
  // showOptimistic() BEFORE posting /cart/add.js: the drawer opens instantly with
  // a placeholder row, and resolveOptimistic()/rollbackOptimistic() retire it
  // when the request settles. While any add is pending the drawer carries
  // .is-optimistic (checkout disabled, totals pulsing). No cart:updated event is
  // dispatched here — gift/progress/upsell widgets must only ever see real cart
  // JSON, which arrives with the server render exactly as before.

  get optimisticPending() {
    if (!this.__optimisticPending) this.__optimisticPending = new Map();
    return this.__optimisticPending;
  }

  buildOptimisticRow(payload, token) {
    const template = document.getElementById('CartDrawer-OptimisticItem');
    if (!template || !template.content.firstElementChild) return null;
    const row = template.content.firstElementChild.cloneNode(true);
    row.setAttribute('data-optimistic-token', token);

    const img = row.querySelector('[data-optimistic-image]');
    if (img) {
      if (payload.image) img.src = payload.image;
      else img.hidden = true;
    }
    const title = row.querySelector('[data-optimistic-title]');
    if (title) {
      title.textContent = payload.title || '';
      if (payload.url) title.href = payload.url;
    }
    const subtitle = row.querySelector('[data-optimistic-subtitle]');
    if (subtitle) subtitle.textContent = payload.subtitle || '';
    const options = row.querySelector('[data-optimistic-options]');
    if (options && payload.options) {
      options.textContent = payload.options;
      options.hidden = false;
    }
    const qty = row.querySelector('[data-optimistic-qty]');
    if (qty) qty.textContent = String(payload.quantity || 1);
    const price = row.querySelector('[data-optimistic-price]');
    // Shop money formats can wrap amounts in HTML (<span class="money">…) —
    // this is a text slot, so keep only the readable amount.
    if (price) price.textContent = String(payload.price || '').replace(/<[^>]*>/g, '');
    return row;
  }

  insertOptimisticRow(row) {
    const contents = this.querySelector('#CartDrawer-CartItems');
    if (!contents) return false;
    let body = contents.querySelector('.cart-items__body');
    if (!body) {
      // First item into an empty cart — build the wrapper the Liquid render
      // would produce so existing styles apply.
      const wrapper = document.createElement('div');
      wrapper.className = 'drawer__cart-items-wrapper';
      wrapper.innerHTML = '<div class="cart-items"><div class="cart-items__body"></div></div>';
      contents.prepend(wrapper);
      body = wrapper.querySelector('.cart-items__body');
    }
    body.prepend(row);
    return true;
  }

  showOptimistic(payload) {
    if (!payload) return null;
    CartDrawer.__optimisticSeq = (CartDrawer.__optimisticSeq || 0) + 1;
    const token = 'opt-' + CartDrawer.__optimisticSeq;
    const row = this.buildOptimisticRow(payload, token);
    if (!row || !this.insertOptimisticRow(row)) return null;

    this.optimisticPending.set(token, payload);
    this.classList.add('is-optimistic');
    this.classList.remove('is-empty');
    const itemsEl = document.getElementById('CartDrawer-Items');
    if (itemsEl) itemsEl.classList.remove('is-empty');

    // Provisional count: real cart + everything still in flight, including this
    // add. handleCartUpdated() recomputes the same way when the sync lands.
    syncOptimisticItemCount();

    this.open();
    return token;
  }

  resolveOptimistic(token) {
    if (!token) return;
    this.optimisticPending.delete(token);
    const row = this.querySelector(`[data-optimistic-token="${token}"]`);
    if (row) row.remove();
    if (this.optimisticPending.size === 0) this.classList.remove('is-optimistic');
  }

  rollbackOptimistic(token, message) {
    if (token) {
      this.optimisticPending.delete(token);
      const row = this.querySelector(`[data-optimistic-token="${token}"]`);
      if (row) row.remove();
      // Recompute rather than subtracting payload.quantity from whatever the
      // badge currently shows: if any real cart sync landed while this add was
      // in flight, the provisional bump is already gone and subtracting again
      // would undercount the items actually in the cart. Unconditional because
      // the recompute is idempotent — the placeholder row may already have been
      // dropped by a renderContents() that has not yet been reapplied.
      syncOptimisticItemCount();
      if (this.optimisticPending.size === 0) this.classList.remove('is-optimistic');
      // If nothing real is in the cart, restore the empty state.
      if (!this.querySelector('.cart-item:not(.cart-item--optimistic)') && this.optimisticPending.size === 0) {
        this.classList.add('is-empty');
        const itemsEl = document.getElementById('CartDrawer-Items');
        if (itemsEl) itemsEl.classList.add('is-empty');
      }
    }
    if (message) this.showToast(message);
  }

  // Re-insert rows for adds still in flight after renderContents() wholesale
  // replaces the item list (rapid multi-add: add #1's server render must not
  // wipe add #2's placeholder).
  reapplyOptimistic() {
    if (this.optimisticPending.size === 0) {
      this.classList.remove('is-optimistic');
      return;
    }
    this.optimisticPending.forEach((payload, token) => {
      if (this.querySelector(`[data-optimistic-token="${token}"]`)) return;
      const row = this.buildOptimisticRow(payload, token);
      if (row) this.insertOptimisticRow(row);
    });
    this.classList.add('is-optimistic');
    this.classList.remove('is-empty');
    const itemsEl = document.getElementById('CartDrawer-Items');
    if (itemsEl) itemsEl.classList.remove('is-empty');
  }

  showToast(message) {
    const toast = document.getElementById('CartDrawer-Toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(this.__toastTimer);
    this.__toastTimer = setTimeout(() => {
      toast.hidden = true;
    }, 4000);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Quick-add flows don't render the cart-drawer section on the add request (it
// is the heaviest section); they mark the drawer stale instead, and open()
// refreshes it. That leaves one gap: an add made while the drawer is ALREADY
// open never triggers a refresh — the list stays stale (only the header count
// self-corrects via handleCartUpdated) until the drawer is closed and reopened.
// All stale-markers should call this instead of setting the flag directly.
if (!window.markCartDrawerStale) {
  window.markCartDrawerStale = function markCartDrawerStale() {
    window.cartDrawerStale = true;
    const drawer = document.querySelector('cart-drawer');
    if (
      drawer &&
      drawer.classList.contains('active') &&
      typeof drawer.refreshStaleContents === 'function'
    ) {
      drawer.refreshStaleContents();
    }
  };
}

let cartDrawerLoadingCount = 0;

function setCartDrawerLoading(isLoading) {
  const drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;
  if (isLoading) {
    cartDrawerLoadingCount += 1;
  } else {
    cartDrawerLoadingCount = Math.max(0, cartDrawerLoadingCount - 1);
  }

  if (cartDrawerLoadingCount > 0) {
    drawer.classList.add('cart-drawer--loading');
  } else {
    drawer.classList.remove('cart-drawer--loading');
  }
}

function renderCartDrawerFromSections(sections, options = {}) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
  if (!sections || typeof sections !== 'object') return;
  cartDrawer.renderContents({ sections }, true, options);
}

function handleCartApiResponse(json, options = {}) {
  if (!json || typeof json !== 'object') return;
  // cart/change.js and cart/update.js return full cart JSON (item_count, items, etc).
  // cart/add.js can return only added item + sections, so don't treat it as a full cart.
  const looksLikeCart =
    typeof json.item_count === 'number' && Array.isArray(json.items);

  if (looksLikeCart) {
    if (typeof window.handleCartUpdated === 'function') {
      window.handleCartUpdated(json);
    } else {
      window.cartJSON = json;
    }
  }

  if (json.sections) renderCartDrawerFromSections(json.sections, options);
}

function formatMoney(cents, format) {
  try {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const moneyFormat = format || window.Shopify.money_format || '${{amount}}';
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
  } catch (e) {
    console.error('formatMoney error', e);
  }

  const value = (cents || 0) / 100;
  return value.toFixed(2);
}

function getProtectionProductIdFromDrawer() {
  try {
    const drawerEl = document.querySelector('cart-drawer');
    const raw = drawerEl?.dataset?.protectionProductId;
    const id = raw ? Number(raw) : 0;
    return Number.isNaN(id) ? 0 : id;
  } catch {
    return 0;
  }
}

// Redo Checkout+ fee line (vendor "re:do"). It stays in the cart after a shopper
// opts in and comes back from checkout, and Redo's widget shows it on its own,
// so like shipping protection it never counts toward the item count, subtotal
// or reward thresholds. The Liquid side tests `vendor == 're:do'`, so this is an
// exact match too: a looser one would let the Liquid-rendered count and this
// one disagree after the first cart update.
function isRedoFeeLine(item) {
  return item?.vendor === 're:do';
}

// Effective item count for a cart payload: shipping protection is a real line
// item but is not something the shopper "added", so it never counts.
function realCartItemCount(cart, protectionId) {
  const items = Array.isArray(cart?.items) ? cart.items : [];
  return items
    .filter((item) => (!protectionId || Number(item.product_id) !== protectionId) && !isRedoFeeLine(item) && item.quantity > 0)
    .reduce((acc, item) => acc + item.quantity, 0);
}

// Quantity of adds that are still in flight (placeholder rows in the drawer).
function pendingOptimisticQuantity() {
  const pending = document.querySelector('cart-drawer')?.optimisticPending;
  if (!pending) return 0;
  let total = 0;
  pending.forEach((payload) => { total += payload?.quantity || 1; });
  return total;
}

// Single source of truth for the badge: last known real cart + adds still in
// flight. Never derive the next value from the element's current text —
// incremental +/- arithmetic drifts, because a real cart sync landing while an
// add is pending overwrites the provisional bump, and a later rollback would
// then subtract from the real count and show too few items.
function syncOptimisticItemCount() {
  const el = document.getElementById('CartDrawer-ItemCount');
  if (!el) return;
  const cart = window.cartJSON;
  // Before theme-globals.js seeds cartJSON there is no real cart to count from;
  // leave the Liquid-rendered value alone rather than zeroing the badge.
  if (!cart || !Array.isArray(cart.items)) return;
  el.textContent = String(realCartItemCount(cart, getProtectionProductIdFromDrawer()) + pendingOptimisticQuantity());
}

function isCartEffectivelyEmpty(cart, protectionProductId) {
  if (!cart) return true;
  const items = Array.isArray(cart.items) ? cart.items : [];
  if (!items.length) return true;
  const visibleItems = items.filter(
    (item) =>
      (!protectionProductId || Number(item.product_id) !== protectionProductId) &&
      !isRedoFeeLine(item) &&
      !(item.properties && item.properties._gift === 'true'),
  );
  return visibleItems.length === 0;
}

if (!window.handleCartUpdated) {
  window.handleCartUpdated = function handleCartUpdated(cart) {
    window.cartJSON = cart;
    const protectionId = getProtectionProductIdFromDrawer();
    const effectiveCount = realCartItemCount(cart, protectionId);

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart, itemCount: effectiveCount },
      }),
    );

    try {
      // Keep any still-in-flight adds in the badge — this sync can land while a
      // placeholder row is showing (rapid multi-add), and dropping their
      // quantity here is what previously left rollbackOptimistic() subtracting
      // from a count that no longer contained its own provisional bump.
      syncOptimisticItemCount();

      const drawer = document.querySelector('cart-drawer');
      const itemsEl = document.getElementById('CartDrawer-Items');
      const isEmpty = isCartEffectivelyEmpty(cart, protectionId);

      if (protectionId && effectiveCount === 0) {
        drawer.classList.add('is-empty');
        return;
      }

      if (drawer) {
        drawer.classList.toggle('is-empty', isEmpty);
      }
      if (itemsEl) {
        itemsEl.classList.toggle('is-empty', isEmpty);
      }
    } catch (e) {
      console.error('Failed to update cart drawer header/empty count', e);
    }
  };
}

if (!window.refreshCartFromServer) {
  window.refreshCartFromServer = async function refreshCartFromServer() {
    const cart = await fetch('/cart.js', { method: 'GET' }).then((r) => r.json());
    if (typeof window.handleCartUpdated === 'function') {
      window.handleCartUpdated(cart);
    } else {
      window.cartJSON = cart;
    }
    return cart;
  };
}

async function removeProtectionForStaff() {
  if (!window.isStaffCustomer) return;
  const protectionProductId = getProtectionProductIdFromDrawer();
  if (!protectionProductId) return;
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const item = cart.items.find((i) => Number(i.product_id) === protectionProductId);
    if (!item) return;
    setCartDrawerLoading(true);
    const json = await fetch(routes.cart_change_url, {
      ...window.fetchConfig(),
      body: JSON.stringify({
        id: item.key,
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    }).then((r) => r.json());
    handleCartApiResponse(json);
  } catch (e) {
    console.error('removeProtectionForStaff error', e);
  } finally {
    setCartDrawerLoading(false);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', removeProtectionForStaff);
} else {
  removeProtectionForStaff();
}

class CartDrawerItems extends CartItems {
  constructor() {
    super();
  }

  render(json) {
    super.render(json);
    try {
      const protectionId = getProtectionProductIdFromDrawer();
      const isEmpty = isCartEffectivelyEmpty(json, protectionId);
      const drawer = document.querySelector('cart-drawer');
      const itemsEl = document.getElementById('CartDrawer-Items');
      if (drawer) {
        drawer.classList.toggle('is-empty', isEmpty);
      }
      if (itemsEl) {
        itemsEl.classList.toggle('is-empty', isEmpty);
      }
    } catch (e) {
      console.error('CartDrawerItems render empty-state sync failed', e);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer-Items',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#Drawer-Footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  async updateQuantity(line, quantity, name) {
    setCartDrawerLoading(true);
    try {
      await super.updateQuantity(line, quantity, name);
    } finally {
      setCartDrawerLoading(false);
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/**
 * Remove button for a merged supply-buybox _tier_group card
 * (snippets/cart-drawer.liquid). A single card there can represent multiple
 * real cart lines (one per flavour), so removing it has to zero out every
 * line in the group in one atomic /cart/update.js call — the plain
 * <cart-remove-button> (assets/cart.js) only knows how to change one line
 * via /cart/change.js and would leave the other flavour(s) behind.
 */
class CartSupplyGroupRemove extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    event.preventDefault();
    if (this.removing) return;

    const keys = (this.dataset.keys || '').split(',').filter(Boolean);
    if (!keys.length) return;

    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    this.removing = true;
    setCartDrawerLoading(true);
    try {
      const json = await fetch(routes.cart_update_url, {
        ...window.fetchConfig(),
        body: JSON.stringify({
          updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());
      handleCartApiResponse(json);
    } catch (e) {
      console.error('Failed to remove supply-buybox group', e);
    } finally {
      this.removing = false;
      setCartDrawerLoading(false);
    }
  }
}

customElements.define('cart-supply-group-remove', CartSupplyGroupRemove);

/**
 * Stepper for a merged supply-buybox _tier_group card
 * (snippets/cart-drawer.liquid). The card stands for one "supply" (the tier
 * picked in the buy box: 2 pouches for a 1-month supply, split across the
 * flavours), so the count it steps is whole supplies, never pouches — that is
 * how a lone flavour stops being reducible to a single loose pouch. Every line
 * in the group moves together in one /cart/update.js call: line quantity =
 * that line's unit (data-lines="key:unit,key:unit") x the new count, and a
 * count of 0 removes the group, the same as the trash icon.
 */
class CartSupplyGroupQuantity extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.lines = (this.dataset.lines || '')
      .split(',')
      .map((pair) => {
        // Cart line keys are "variantId:hash", so split on the LAST colon.
        const at = pair.lastIndexOf(':');
        if (at === -1) return null;
        return { key: pair.slice(0, at), unit: parseInt(pair.slice(at + 1), 10) || 1 };
      })
      .filter(Boolean);
    this.count = parseInt(this.dataset.count, 10) || 1;

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.setCount(this.count + (button.name === 'plus' ? 1 : -1));
      })
    );
    this.input?.addEventListener('change', () => this.setCount(parseInt(this.input.value, 10)));
  }

  async setCount(next) {
    if (!this.lines.length) return;
    if (!Number.isFinite(next) || next < 0) next = 0;
    if (next === this.count || this.updating) {
      if (this.input) this.input.value = this.count;
      return;
    }

    const updates = {};
    this.lines.forEach((line) => {
      updates[line.key] = line.unit * next;
    });

    this.updating = true;
    setCartDrawerLoading(true);
    try {
      const json = await fetch(routes.cart_update_url, {
        ...window.fetchConfig(),
        body: JSON.stringify({
          updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());

      // A cart write: drop the shared /cart.js snapshot so a concurrent
      // post-add chore re-reads instead of publishing its stale copy.
      if (typeof window.invalidateCartCache === 'function') window.invalidateCartCache();

      const problem = json && (json.errors || json.description || (json.status && json.message));
      if (problem) {
        if (this.input) this.input.value = this.count;
        this.showError(typeof problem === 'string' ? problem : 'Could not update the cart');
        return;
      }
      // The drawer re-renders from sections, which replaces this element with
      // one carrying the server's count (stock caps included).
      handleCartApiResponse(json);
    } catch (e) {
      console.error('Failed to update supply-buybox group quantity', e);
      if (this.input) this.input.value = this.count;
    } finally {
      this.updating = false;
      setCartDrawerLoading(false);
    }
  }

  showError(message) {
    const errorText = this.closest('.cart-item__quantity')?.querySelector('.cart-item__error-text');
    if (errorText) errorText.textContent = message;
  }
}

customElements.define('cart-supply-group-quantity', CartSupplyGroupQuantity);

// Free-gift and progress-bar thresholds are set in the store currency (AUD).
// In another currency they scale by the rate plus a 1.5% buffer. The gift and
// the bar both go through this one function so they always unlock at the same
// total. Shopify.currency.rate is a string on the live site ("1.0"), and a
// strict === 1 on it once sent AUD through the conversion: A$180 became
// A$182.70 for the gift while the bar already said everything was unlocked.
function convertThresholdCents(thresholdCents) {
  const rate = Number(window.Shopify?.currency?.rate) || 1;
  const cents = Number(thresholdCents) || 0;
  return Math.round(rate === 1 ? cents : cents * rate * (1 + 0.015));
}

class CartDrawerGift extends HTMLElement {
  static _enforcing = false;
  static _lastTotal = null;

  connectedCallback() {
    this.button = this.querySelector('.cart-drawer-gift__button');
    this.variantSelect = this.querySelector('[data-gift-variant-select]');
    this.variantId = Number(this.dataset.variantId);
    this.productId = Number(this.dataset.productId);
    this.thresholdCents = Number(this.dataset.thresholdCents || '0');
    this.protectionProductId = Number(this.dataset.protectionProductId || '0');
    this.giftIndex = this.dataset.giftIndex || '1';
    // Sold out (sections/cart-drawer.liquid): never offered, only here so
    // enforceAllGifts still polices a line claimed before it sold out.
    this.soldOut = this.hasAttribute('data-sold-out');
    this.onClick = this.onClick.bind(this);
    this.button?.addEventListener('click', this.onClick);
    if (this.variantSelect) {
      this.variantId = Number(this.variantSelect.value);
      this.variantSelect.addEventListener('change', () => {
        this.variantId = Number(this.variantSelect.value);
      });
    }

    this.onCartUpdated = (event) => {
      const cart = event?.detail?.cart;
      if (!cart || CartDrawerGift._enforcing) return;
      this.syncVisibility(cart);
    };
    document.addEventListener('cart:updated', this.onCartUpdated);

    if (window.cartJSON && typeof window.cartJSON === 'object') {
      this.syncVisibility(window.cartJSON);
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    document.removeEventListener('cart:updated', this.onCartUpdated);
    clearTimeout(this._errorResetTimer);
  }

  async onClick() {
    if (!this.variantId) return;
    // Prevent double-click / spam
    if (this.button?.disabled) return;

    const isCartPage = window.location.pathname === '/cart';
    const originalLabel = this.button?.innerHTML;

    try {
      // Disable button + show loading state
      if (this.button) {
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        this.button.innerHTML = `
          <span class="cart-drawer-gift__btn-spinner" aria-hidden="true"></span>
          <span class="visually-hidden">Adding…</span>
        `;
      }
      setCartDrawerLoading(true);

      const effectiveThresholdCents = CartDrawerGift.convertThresholdCents(this.thresholdCents);
      const addBody = {
        items: [{
          id: this.variantId,
          quantity: 1,
          properties: {
            _gift: 'true',
            _gift_index: String(this.giftIndex),
            _threshold: String(effectiveThresholdCents),
          },
        }],
      };

      if (isCartPage) {
        // 1. Add the gift
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addBody),
        });
        const addJson = await addResponse.json();
        if (!addResponse.ok) {
          throw new Error(addJson.description || addJson.message || 'Failed to add gift');
        }

        // 2. Re-render main-cart sections the same way CartItems.updateQuantity does —
        //    POST to cart/update.js with empty updates to get fresh rendered HTML
        const cartItemsEl = document.querySelector('cart-items');
        const sectionsToFetch = cartItemsEl
          ? cartItemsEl.getSectionsToRender().map((s) => s.section)
          : ['cart-icon-bubble'];

        const json = await fetch(routes.cart_update_url, {
          ...window.fetchConfig(),
          body: JSON.stringify({
            updates: {},
            sections: sectionsToFetch,
            sections_url: window.location.pathname,
          }),
        }).then((r) => r.json());

        // 3. Let CartItems handle DOM updates + dispatch cart:updated
        if (cartItemsEl) {
          cartItemsEl.render(json);
        } else if (typeof window.handleCartUpdated === 'function') {
          window.handleCartUpdated(json);
        }
        this.resetButton(originalLabel);
        return;
      }

      // Other pages — add gift and open/refresh cart drawer
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          ...addBody,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const json = await addResponse.json();
      if (!addResponse.ok) {
        throw new Error(json.description || json.message || 'Failed to add gift');
      }
      handleCartApiResponse(json, { skipExclusivePanel: true });

      if (typeof window.refreshCartFromServer === 'function') {
        await window.refreshCartFromServer();
      }
      this.resetButton(originalLabel);
    } catch (e) {
      console.error('Failed to add free gift', e);
      if (this.button && this.button.isConnected && originalLabel !== undefined) {
        this.button.classList.remove('is-loading');
        this.button.innerHTML = e?.message || 'Failed to add — try again';
        this.button.disabled = false;
        clearTimeout(this._errorResetTimer);
        this._errorResetTimer = setTimeout(() => this.resetButton(originalLabel), 3000);
      }
    } finally {
      setCartDrawerLoading(false);
    }
  }

  // The gift container lives outside the sections CartDrawer/CartItems re-render
  // (see getSectionsToRender), so this element/button is never recreated by a
  // server HTML swap — its loading/disabled state must be reset explicitly here.
  resetButton(originalLabel) {
    clearTimeout(this._errorResetTimer);
    if (this.button && this.button.isConnected && originalLabel !== undefined) {
      this.button.classList.remove('is-loading');
      this.button.innerHTML = originalLabel;
      this.button.disabled = false;
    }
  }

  syncVisibility(cart) {
    if (this.soldOut || !this.thresholdCents || !this.productId) {
      this.hidden = true;
      CartDrawerGift.updateContainerVisibility();
      return;
    }

    const items = Array.isArray(cart?.items) ? cart.items : [];
    const total = CartDrawerGift.calcEffectiveTotal(cart, this.protectionProductId);

    const hasGift = items.some(
      (item) =>
        Number(item.product_id) === this.productId &&
        item.properties &&
        (String(item.properties._gift_index) === String(this.giftIndex) ||
         item.properties._Special === 'Free Gift Promotion'),
    );

    const thresholdCents = CartDrawerGift.convertThresholdCents(this.thresholdCents);

    const thresholdOk = total >= thresholdCents;
    this.hidden = !(thresholdOk && !hasGift);
    CartDrawerGift.updateContainerVisibility();
  }

  static updateContainerVisibility() {
    // Update both cart drawer and main cart gift containers
    document.querySelectorAll('.js-cart-drawer-gifts-container, .js-main-cart-gifts-container').forEach((container) => {
      const anyVisible = container.querySelector('cart-drawer-gift:not([hidden])');
      container.hidden = !anyVisible;
    });
  }

  static convertThresholdCents(thresholdCents) {
    return convertThresholdCents(thresholdCents);
  }

  static calcEffectiveTotal(cart, protectionProductId) {
    if (!cart) return 0;
    let total = typeof cart.total_price === 'number' ? cart.total_price : 0;
    const items = Array.isArray(cart.items) ? cart.items : [];
    items.forEach((item) => {
      if (item.gift_card) total -= item.final_line_price || 0;
      if (protectionProductId && Number(item.product_id) === protectionProductId)
        total -= item.final_line_price || 0;
      if (isRedoFeeLine(item)) total -= item.final_line_price || 0;
      if (item.properties && item.properties._gift === 'true')
        total -= item.final_line_price || 0;
    });
    return total;
  }

  /**
   * - Remove gifts whose threshold is no longer met
   * - Cap quantity to 1 for gifts that have qty > 1
   */
  static async enforceAllGifts(cart) {
    if (CartDrawerGift._enforcing || !cart) return;
    const items = Array.isArray(cart.items) ? cart.items : [];
    const giftEls = document.querySelectorAll('cart-drawer-gift');
    if (!giftEls.length) return;

    const protectionProductId = giftEls[0]?.protectionProductId || 0;
    const total = CartDrawerGift.calcEffectiveTotal(cart, protectionProductId);

    const updates = {};

    giftEls.forEach((el) => {
      const giftIndex = el.giftIndex || el.dataset?.giftIndex;
      const productId = el.productId || Number(el.dataset?.productId);
      const thresholdCents = el.thresholdCents || Number(el.dataset?.thresholdCents || 0);

      const convertedThreshold = CartDrawerGift.convertThresholdCents(thresholdCents);

      const thresholdOk = total >= convertedThreshold;

      const giftItem = items.find(
        (item) =>
          Number(item.product_id) === productId &&
          item.properties &&
          (String(item.properties._gift_index) === String(giftIndex) ||
           item.properties._Special === 'Free Gift Promotion'),
      );

      if (!giftItem || !giftItem.key) return;

      if (!thresholdOk) {
        updates[giftItem.key] = 0;
      } else if (Number(giftItem.quantity) > 1) {
        updates[giftItem.key] = 1;
      }
    });
    if (!Object.keys(updates).length) return;

    CartDrawerGift._enforcing = true;
    try {
      setCartDrawerLoading(true);
      const json = await fetch(routes.cart_update_url, {
        ...window.fetchConfig(),
        body: JSON.stringify({
          updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());
      handleCartApiResponse(json, { skipExclusivePanel: true });
    } catch (e) {
      console.error('Failed to batch-update gift lines', e);
    } finally {
      CartDrawerGift._enforcing = false;
      setCartDrawerLoading(false);
    }
  }

  static async refreshDrawerSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
    const data = await fetch('/?sections=cart-drawer,cart-icon-bubble', { method: 'GET' }).then((r) => r.json());
    cartDrawer.renderContents({ sections: data }, true, { skipExclusivePanel: true });
  }
}

customElements.define('cart-drawer-gift', CartDrawerGift);

class CartDrawerProgress extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;

    const data = window.cart_progress_data;
    if (!data) {
      // Retry while the inline data script parses, but give up eventually —
      // an unbounded 50ms loop spins forever when the section never renders it.
      this._dataRetries = (this._dataRetries || 0) + 1;
      if (this._dataRetries <= 100) setTimeout(() => this.connectedCallback(), 50);
      return;
    }

    this._initialized = true;

    if (!data.enabled || !Array.isArray(data.thresholds) || !data.thresholds.length) {
      this.style.display = 'none';
      return;
    }

    this.protectionProductId = Number(data.protectionProductId || 0);
    this.finalMessage = data.finalMessage || '';
    this.rtdMessage = data.rtdMessage || '';
    this.thresholds = data.thresholds
      .filter((t) => t.threshold > 0)
      .map((t) => {
        // Same conversion as CartDrawerGift, so a milestone shows as reached
        // exactly when its gift becomes claimable.
        const thresholdCents = convertThresholdCents(t.thresholdCents);
        return { ...t, threshold: thresholdCents / 100, thresholdCents };
      })
      .sort((a, b) => a.threshold - b.threshold);

    if (!this.thresholds.length) {
      this.style.display = 'none';
      return;
    }

    this.thresholdsAll = this.thresholds;
    this._hasRtd = null;

    this.messageEl = this.querySelector('.cart-drawer-progress__message');
    this.fillEl = this.querySelector('.cart-drawer-progress__fill');

    const barEl = this.querySelector('.cart-drawer-progress__bar');
    this.barEl = barEl;

    const readIcon = (attr) => {
      const el = document.querySelector(`[${attr}]`);
      if (!el) return '';
      if (el instanceof HTMLTemplateElement) {
        // DocumentFragment has no .innerHTML — clone into a div to serialize
        const tmp = document.createElement('div');
        tmp.appendChild(el.content.cloneNode(true));
        return tmp.innerHTML;
      }
      return el.innerHTML || '';
    };
    this.truckIcon = readIcon('data-cart-progress-truck-icon');
    this.giftIcon = readIcon('data-cart-progress-gift-icon');

    this.syncThresholdsForRtd();

    this.onCartUpdated = (event) => {
      const cart = event?.detail?.cart || window.cartJSON;
      const runner = () => this.renderFromCart(cart);
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(runner);
      } else {
        setTimeout(runner, 0);
      }
    };

    document.addEventListener('cart:updated', this.onCartUpdated);

    if (window.cartJSON && typeof window.cartJSON === 'object') {
      this.renderFromCart(window.cartJSON);
    } else {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((json) => {
          window.cartJSON = json;
          this.renderFromCart(json);
        })
        .catch(console.error);
    }
  }

  getHasRtd() {
    try {
      return Boolean(document.querySelector('#CartDrawer-Items [data-cart-has-rtd="true"]'));
    } catch (e) {
      return false;
    }
  }

  syncThresholdsForRtd() {
    const hasRtd = this.getHasRtd();
    if (this._hasRtd === hasRtd && Array.isArray(this.thresholds) && this.maxThreshold) return;
    this._hasRtd = hasRtd;

    // Hide the "shipping" milestone (the one without a productId) when RTD exists.
    this.thresholds = hasRtd
      ? this.thresholdsAll.filter((t) => t.productId)
      : this.thresholdsAll;

    if (!this.thresholds.length) {
      this.style.display = 'none';
      return;
    }

    this.style.display = '';
    this.maxThreshold = Math.max(...this.thresholds.map((t) => t.threshold));
    this.buildMarkers();
  }

  buildMarkers() {
    if (!this.barEl) return;
    this.barEl.querySelectorAll('.cart-drawer-progress__marker').forEach((el) => el.remove());

    this.thresholds.forEach((t) => {
      const marker = document.createElement('div');
      marker.className = 'cart-drawer-progress__marker';
      marker.dataset.progressMarkerIndex = t.index;

      const pct = (t.threshold / this.maxThreshold) * 100;
      if (pct >= 100) {
        marker.style.right = '-6px';
      } else {
        marker.style.left = `calc(${pct}% - 31px)`;
      }

      const amountDiv = document.createElement('div');
      amountDiv.className = 'cart-drawer-progress__marker-amount';
      amountDiv.dataset.progressMarkerIndex = t.index;
      amountDiv.innerHTML = formatMoney(t.thresholdCents);

      const iconDiv = document.createElement('div');
      iconDiv.className = 'cart-drawer-progress__marker-icon';
      iconDiv.innerHTML = t.productId ? this.giftIcon : this.truckIcon;

      const labelDiv = document.createElement('div');
      labelDiv.className = 'cart-drawer-progress__marker-label';
      labelDiv.textContent = t.title || '';

      marker.appendChild(amountDiv);
      marker.appendChild(iconDiv);
      marker.appendChild(labelDiv);
      this.barEl.appendChild(marker);
    });

    this.markerEls = this.querySelectorAll('.cart-drawer-progress__marker');
  }

  disconnectedCallback() {
    if (this.onCartUpdated) {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }
  }

  renderFromCart(cart) {
    if (!cart || !this.thresholds.length) return;
    this.syncThresholdsForRtd();
    if (!this.thresholds.length) return;

    const items = Array.isArray(cart.items) ? cart.items : [];
    let totalGiftCards = 0;
    let totalProtection = 0;
    let totalGifts = 0;

    items.forEach((item) => {
      if (item.gift_card) {
        totalGiftCards += item.final_line_price || 0;
      }
      if (
        (this.protectionProductId && Number(item.product_id) === this.protectionProductId) ||
        isRedoFeeLine(item)
      ) {
        totalProtection += item.final_line_price || 0;
      }
      if (item.properties && item.properties._gift === 'true') {
        totalGifts += item.final_line_price || 0;
      }
    });

    const cartTotalWithoutExtras = (cart.total_price || 0) - totalGiftCards - totalProtection - totalGifts;
    const cartValue = cartTotalWithoutExtras / 100;

    let progressPercent = (cartValue / this.maxThreshold) * 100;
    progressPercent = Math.max(0, Math.min(100, progressPercent));

    if (this.fillEl) {
      this.fillEl.style.width = `${progressPercent}%`;
    }

    // markerEls is only assigned when buildMarkers found the bar element — a
    // missing bar must not throw here and take gift enforcement down with it.
    (this.markerEls || []).forEach((markerEl) => {
      const idx = Number(markerEl.dataset.progressMarkerIndex);
      const t = this.thresholds.find((th) => th.index === idx);
      if (!t) return;
      const isComplete = cartValue >= t.threshold;
      markerEl.classList.toggle('cart-drawer-progress__marker--active', isComplete);
    });

    const message = this.computeMessage(cartValue, cartTotalWithoutExtras);
    if (this.messageEl) {
      this.messageEl.innerHTML = message || '';
      this.messageEl.style.display = message ? '' : 'none';
    }

    if (typeof CartDrawerGift !== 'undefined') {
      CartDrawerGift.enforceAllGifts(cart);
    }
  }

  computeMessage(cartValue, cartTotalCents) {
    const hasRtd = Boolean(this._hasRtd);
    for (const t of this.thresholds) {
      if (cartValue < t.threshold) {
        const remainingCents = Math.max(0, t.thresholdCents - cartTotalCents);
        const remainingMoney = formatMoney(remainingCents);
        const msg = hasRtd && t.rtdProgressMessage ? t.rtdProgressMessage : t.progressMessage;
        return String(msg || '').replace('[amount]', remainingMoney);
      }
    }

    if (hasRtd && this.rtdMessage) return this.rtdMessage;
    return this.finalMessage;
  }
}

customElements.define('cart-drawer-progress', CartDrawerProgress);

/**
 * Store credit promo line (cart drawer + cart page).
 * Markup is rendered by snippets/store-credit-message.liquid with a Liquid-seeded
 * amount; this element keeps the amount in sync on JS-driven cart updates.
 * Mirrors CartDrawerProgress: recomputes from the /cart.js JSON on `cart:updated`,
 * excluding gift cards, shipping protection and free-gift line items.
 */
class StoreCreditMessage extends HTMLElement {
  connectedCallback() {
    // Only fall back on missing/NaN — a configured rate of 0 must stay 0, not become 10%.
    const parsedRate = parseInt(this.dataset.storeCreditRate, 10);
    this.rate = Number.isNaN(parsedRate) ? 10 : parsedRate;
    this.amountEl = this.querySelector('[data-store-credit-amount]');
    this.protectionProductId = getProtectionProductIdFromDrawer();

    this.onCartUpdated = (event) => {
      const cart = event?.detail?.cart || window.cartJSON;
      this.renderFromCart(cart);
    };
    document.addEventListener('cart:updated', this.onCartUpdated);

    if (window.cartJSON) this.renderFromCart(window.cartJSON);
  }

  disconnectedCallback() {
    if (this.onCartUpdated) {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }
  }

  renderFromCart(cart) {
    if (!cart) return;
    const base = Math.max(0, CartDrawerGift.calcEffectiveTotal(cart, this.protectionProductId));
    // Floor to the cent so we never promise more than the Liquid-seeded amount (round down to be safe).
    const credit = Math.floor((base * this.rate) / 100 + 1e-6);

    if (this.amountEl) this.amountEl.innerHTML = formatMoney(credit);
    this.toggleAttribute('hidden', credit <= 0);
  }
}

if (!customElements.get('store-credit-message')) {
  customElements.define('store-credit-message', StoreCreditMessage);
}

/**
 * Clone cart-drawer-gift elements from the global template into the main cart
 * page container so gifts appear on both the drawer and the /cart page.
 */
function initMainCartGifts(force = false) {
  const template = document.getElementById('cart-drawer-gifts-global-template');
  const container = document.querySelector('.js-main-cart-gifts-container');
  if (!template || !container) return;
  // Skip if already populated — unless forced (e.g. after section re-render wipes DOM)
  if (!force && container.children.length > 0) return;

  // Clear any stale clones before re-populating
  container.innerHTML = '';

  const content = template.content.cloneNode(true);
  const gifts = content.querySelectorAll('cart-drawer-gift');
  if (!gifts.length) return;

  // Give cloned gifts unique IDs to avoid DOM conflicts with drawer copies
  gifts.forEach((gift) => {
    const origId = gift.id;
    if (origId) gift.id = origId + '-main-cart';
  });

  container.appendChild(content);
  container.hidden = false;

  // Let the container visibility be managed by the same static method
  CartDrawerGift.updateContainerVisibility();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMainCartGifts);
} else {
  initMainCartGifts();
}

class CartDrawerDiscount extends HTMLElement {
  static storageKey = 'cart_drawer_discount_code';

  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="discount"]');
    this.status = this.querySelector('.cart-drawer-discount__status');
    this.meta = this.querySelector('.cart-drawer-discount__meta');
    this.codeEl = this.querySelector('[data-discount-code]');
    this.removeBtn = this.querySelector('[data-discount-remove]');
    this.form?.addEventListener('submit', this.onSubmit);
    this.removeBtn?.addEventListener('click', this.onRemove);

    // this.restore();
    this.bindCheckoutRedirect();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
    this.removeBtn?.removeEventListener('click', this.onRemove);
    document.removeEventListener('click', this.onCheckoutClick, true);
  }

  restore() {
    const domCode = (this.codeEl?.textContent || '').trim();
    if (domCode) {
      window.localStorage.setItem(CartDrawerDiscount.storageKey, domCode);
      if (this.input) this.input.value = domCode;
      this.setAppliedUI(domCode);
      return;
    }

    const cartCode = window.cartJSON?.discount_codes?.[0]?.code?.trim?.() || '';
    if (cartCode) {
      window.localStorage.setItem(CartDrawerDiscount.storageKey, cartCode);
      if (this.input) this.input.value = cartCode;
      this.setAppliedUI(cartCode);
      return;
    }

    const code = (window.localStorage.getItem(CartDrawerDiscount.storageKey) || '').trim();
    if (!code) return;
    if (this.input) this.input.value = code;
    this.setAppliedUI(code);
  }

  setStatus(message = '') {
    if (!this.status) return;
    this.status.textContent = message;
    this.status.classList.remove('cart-drawer-discount__status--error');
  }

  setAppliedUI(code) {
    if (this.codeEl) this.codeEl.textContent = code;
    if (this.meta) this.meta.hidden = false;
    this.setStatus('');
  }

  clearAppliedUI() {
    if (this.codeEl) this.codeEl.textContent = '';
    if (this.meta) this.meta.hidden = true;
    this.setStatus('');
  }

  onRemove = async () => {
    try {
      setCartDrawerLoading(true);
      this.setStatus('Removing…');

      // Shopify Ajax Cart API supports removing all cart discounts via discount:''.
      // (Not a dedicated "remove one specific code" endpoint.)
      const resp = await fetch(`${routes.cart_update_url}`, {
        ...window.fetchConfig(),
        ...{
          body: JSON.stringify({
            discount: '',
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        },
      });

      const json = await resp.json().catch(() => ({}));
      if (!resp.ok || json?.status) {
        throw new Error(json?.description || 'cart-update-failed');
      }

      // Prefer section patch returned from /cart/update.js; otherwise fallback to full drawer refresh.
      handleCartApiResponse(json);
      if (!json?.sections) {
        await this.refreshDrawerSections();
      }

      window.localStorage.removeItem(CartDrawerDiscount.storageKey);
      this.clearAppliedUI();
    } catch (e) {
      console.error('CartDrawerDiscount remove error', e);
      // Keep UI untouched on failure.
      this.setStatus('');
    } finally {
      setCartDrawerLoading(false);
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();

    const code = (this.input?.value || '').trim();
    if (!code) return;

    this.setStatus('Applying…');

    try {
      const resp = await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET' });
      if (!resp.ok) throw new Error('discount-endpoint-failed');

      const cart = await window.refreshCartFromServer();
      const applicable =
        Array.isArray(cart?.discount_codes) &&
        cart.discount_codes.length > 0 &&
        cart.discount_codes[0]?.applicable;

      if (!applicable) throw new Error('discount-not-applicable');

      window.localStorage.setItem(CartDrawerDiscount.storageKey, code);
      this.setAppliedUI(code);
      this.setStatus('Applied');

      // Redo prices its fee on the cart after discounts, but /discount/<code>
      // is not a /cart/ request, so its cart watcher never sees the change.
      document.dispatchEvent(new CustomEvent('redo:reload-cart'));

      await this.refreshDrawerSections();
    } catch (e) {
      window.localStorage.removeItem(CartDrawerDiscount.storageKey);
      this.clearAppliedUI();
      // A cart holding a 'no-discounts' product is the likely reason a code
      // won't apply, so name it instead of the generic invalid-code message.
      const excludedMessage = this.getAttribute('data-discount-excluded');
      this.setStatus(excludedMessage || 'Invalid discount code');
      if (this.status) this.status.classList.add('cart-drawer-discount__status--error');
    }
  };

  async refreshDrawerSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    const data = await fetch('/?sections=cart-drawer,cart-icon-bubble', { method: 'GET' }).then((r) => r.json());
    cartDrawer.renderContents({ sections: data });
  }

  bindCheckoutRedirect() {
    document.addEventListener('click', this.onCheckoutClick, true);
  }

  onCheckoutClick = (event) => {
    const btn = event.target?.closest?.('#CartDrawer-Checkout');
    if (!btn) return;

    const code = (window.localStorage.getItem(CartDrawerDiscount.storageKey) || '').trim();
    if (!code) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
  };
}

customElements.define('cart-drawer-discount', CartDrawerDiscount);

class CartDrawerProtection extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="checkbox"]');
    this.variantId = this.dataset.variantId;
    this.productId = Number(this.dataset.productId);
    this.onChange = this.onChange.bind(this);
    this.input?.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.onChange);
  }

  async onChange() {
    if (!this.variantId) return;
    const isCartPage = window.location.pathname === '/cart';

    // Prevent spam during request
    if (this.input) this.input.disabled = true;

    try {
      setCartDrawerLoading(true);

      // Helper: refresh main cart sections like CartItems does
      const refreshMainCart = async () => {
        const cartItemsEl = document.querySelector('cart-items');
        if (!cartItemsEl) return;
        const sectionsToFetch = cartItemsEl.getSectionsToRender().map((s) => s.section);
        const json = await fetch(routes.cart_update_url, {
          ...window.fetchConfig(),
          body: JSON.stringify({
            updates: {},
            sections: sectionsToFetch,
            sections_url: window.location.pathname,
          }),
        }).then((r) => r.json());
        cartItemsEl.render(json);
      };

      if (this.input.checked) {
        // Add protection product
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.variantId), quantity: 1, properties: {} }],
            ...(!isCartPage && {
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          }),
        }).then((r) => r.json()).then((json) => {
          if (!isCartPage) handleCartApiResponse(json);
        });

        if (isCartPage) {
          await refreshMainCart();
        } else if (typeof window.refreshCartFromServer === 'function') {
          await window.refreshCartFromServer();
        }
      } else {
        // Remove protection product
        const cartBefore = window.cartJSON && typeof window.cartJSON === 'object'
          ? window.cartJSON
          : await window.refreshCartFromServer();

        const protectionItem = Array.isArray(cartBefore?.items)
          ? cartBefore.items.find((it) => Number(it.product_id) === this.productId)
          : null;

        if (protectionItem) {
          // Use cart item key (format: "variantId:hash") — the canonical Shopify identifier
          const itemId = protectionItem.key || this.variantId;
          if (isCartPage) {
            await fetch(routes.cart_change_url, {
              ...window.fetchConfig(),
              body: JSON.stringify({ id: itemId, quantity: 0 }),
            });
            await refreshMainCart();
          } else {
            const json = await fetch(routes.cart_change_url, {
              ...window.fetchConfig(),
              body: JSON.stringify({
                id: itemId,
                quantity: 0,
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname,
              }),
            }).then((r) => r.json());
            handleCartApiResponse(json);
          }
        }
      }
    } catch (e) {
      // Revert toggle on error
      if (this.input) this.input.checked = !this.input.checked;
    } finally {
      // Re-enable checkbox
      if (this.input) this.input.disabled = false;
      // Sync all other protection instances (cart drawer & main cart)
      const checked = this.input?.checked;
      document.querySelectorAll('cart-drawer-protection').forEach((el) => {
        if (el !== this && el.querySelector('input[type="checkbox"]')) {
          el.querySelector('input[type="checkbox"]').checked = checked;
        }
      });
      setCartDrawerLoading(false);
    }
  }

  async refreshDrawerSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
    const data = await fetch('/?sections=cart-drawer,cart-icon-bubble', { method: 'GET' }).then((r) => r.json());
    cartDrawer.renderContents({ sections: data });
  }
}

customElements.define('cart-drawer-protection', CartDrawerProtection);

// Custom event: open cart drawer and optionally reload its content.
// Usage:
//   document.dispatchEvent(new CustomEvent('cart:open'));              // open + reload
//   document.dispatchEvent(new CustomEvent('cart:open', { detail: { reload: false } }));  // open only
document.addEventListener('cart:open', async (event) => {
  if (window.location.pathname === '/cart') return;

  const reload = !event.detail || event.detail.reload !== false;
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  // Open immediately, then reload content in background with loading indicator
  cartDrawer.open();

  if (!reload) return;

  try {
    setCartDrawerLoading(true);
    const [sectionsData] = await Promise.all([
      fetch('/?sections=cart-drawer,cart-icon-bubble', { method: 'GET' }).then((r) => r.json()),
      typeof window.refreshCartFromServer === 'function' ? window.refreshCartFromServer() : Promise.resolve(),
    ]);
    cartDrawer.renderContents({ sections: sectionsData }, false);
  } catch (e) {
    console.error('cart:open reload failed', e);
  } finally {
    setCartDrawerLoading(false);
  }
});

// Redo Checkout+ edits the cart on its own: it strips any fee line it did not
// just add, such as the one a shopper carries back from checkout. It announces
// that with redo:render-cart on document.body and leaves the re-render to the
// theme. Without one the drawer and /cart keep the fee in their count and
// subtotal, and their line numbers point one past the real cart, so the
// quantity buttons fail with "line parameter is invalid".
document.addEventListener('redo:render-cart', async () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.refreshStaleContents === 'function') {
    cartDrawer.refreshStaleContents();
  }

  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return;
  try {
    const sections = [...new Set(cartItems.getSectionsToRender().map((s) => s.section).filter(Boolean))];
    const [sectionsData, cart] = await Promise.all([
      fetch(`${routes.cart_url}?sections=${sections.join(',')}`).then((r) => r.json()),
      fetch('/cart.js').then((r) => r.json()),
    ]);
    cartItems.render({ ...cart, sections: sectionsData });
  } catch (e) {
    console.error('redo:render-cart /cart refresh failed', e);
  }
});


class CartDrawerSubscription extends HTMLElement {
  connectedCallback() {
    this.lineKey = this.dataset.lineKey;
    this.quantity = Number(this.dataset.quantity || '1');
    this.checkbox = this.querySelector('.cart-drawer-subscription__checkbox');
    this.select = this.querySelector('.cart-drawer-subscription__select');
    this.selectWrapper = this.querySelector('.cart-drawer-subscription__select-wrapper');

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.onToggle);
    }
    if (this.select) {
      this.select.addEventListener('change', this.onChangeSelect);
    }
  }

  disconnectedCallback() {
    if (this.checkbox) {
      this.checkbox.removeEventListener('change', this.onToggle);
    }
    if (this.select) {
      this.select.removeEventListener('change', this.onChangeSelect);
    }
  }

  onToggle = async () => {
    const enabled = this.checkbox.checked;

    if (!enabled) {
      if (this.selectWrapper) {
        this.selectWrapper.classList.add('cart-drawer-subscription__select-wrapper--hidden');
      }
      await this.updateSubscription(null);
      return;
    }

    if (this.selectWrapper) {
      this.selectWrapper.classList.remove('cart-drawer-subscription__select-wrapper--hidden');
    }

    // Wait for the customer to actually pick a plan (onChangeSelect) instead of
    // converting immediately on a placeholder/default option.
    const sellingPlanId = this.select ? Number(this.select.value || '0') : 0;
    if (!sellingPlanId) return;
    await this.updateSubscription(sellingPlanId);
  };

  onChangeSelect = async () => {
    if (!this.checkbox || !this.checkbox.checked) return;
    const sellingPlanId = Number(this.select.value || '0');
    if (!sellingPlanId) return;
    await this.updateSubscription(sellingPlanId);
  };

  async updateSubscription(sellingPlanId) {
    if (!this.lineKey) return;

    try {
      setCartDrawerLoading(true);

      const payload = {
        id: this.lineKey,
        quantity: this.quantity,
      };

      if (sellingPlanId) {
        payload.selling_plan = sellingPlanId;
      } else {
        payload.selling_plan = null;
      }

      const body = JSON.stringify({
        ...payload,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      const json = await fetch(`${routes.cart_change_url}`, {
        ...window.fetchConfig(),
        ...{ body },
      }).then((r) => r.json());
      handleCartApiResponse(json);
    } catch (e) {
      console.error('Failed to update subscription in cart drawer', e);
    } finally {
      setCartDrawerLoading(false);
    }
  }
}

customElements.define('cart-drawer-subscription', CartDrawerSubscription);

// Module-level cache of the last-rendered "frequently bought with" upsell HTML,
// keyed by recommendation set (base product + cart token + limit + section).
// The cart drawer re-renders #CartDrawer-Items wholesale on several in-drawer
// actions (adding an upsell item, applying a discount code, quantity changes),
// which destroys and recreates the <cart-drawer-upsell> element. Without this
// cache each recreation re-fetches and visibly re-renders the module ("comes up
// again"). Surviving the rebuild from cache makes it render once per set.
let cartUpsellCache = { key: '', html: '' };

class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId || 'cart-drawer-recommendation';
    this.limit = Number(this.dataset.limit);
    this.root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.initialized = false;
    this._swiper = null;
    this._loading = false;
    this._lastRequestKey = '';
    this._abortController = null;

    this.load = this.load.bind(this);
    document.addEventListener('cart:updated', this.load);
    this.load();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.load);
    try {
      this._abortController?.abort?.();
    } catch (e) { }
  }

  async load() {
    if (this._loading) return;
    if (this.initialized && !window.cartJSON) {
      return;
    }
    try {
      const cart =
        (window.cartJSON && typeof window.cartJSON === 'object'
          ? window.cartJSON
          : null) || (await window.refreshCartFromServer?.());

      if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
        this.style.display = 'none';
        return;
      }

      const baseItem = cart.items.find((item) => {
        if (item.gift_card) return false;
        if (item.properties && item.properties._gift === 'true') return false;
        return true;
      });

      if (!baseItem || !baseItem.product_id) {
        this.style.display = 'none';
        return;
      }

      const requestKey = `${String(baseItem.product_id)}|${String(cart?.token || '')}|${String(this.limit)}|${String(this.sectionId)}`;
      if (requestKey && requestKey === this._lastRequestKey) return;
      this._lastRequestKey = requestKey;

      const url =
        (window.routes && window.routes.product_recommendations_url
          ? window.routes.product_recommendations_url
          : this.root + 'recommendations/products') +
        '?section_id=' +
        encodeURIComponent(this.sectionId) +
        '&product_id=' +
        encodeURIComponent(baseItem.product_id) +
        '&limit=' +
        encodeURIComponent(this.limit)

      this._loading = true;
      try {
        let html;
        // Reuse the cached render when the recommendation set is unchanged (same
        // base product). This lets the upsell survive a cart-drawer re-render —
        // adding an upsell item, entering a discount code — without a network
        // round-trip or the disappear/reappear flash. It effectively renders once
        // per recommendation set instead of on every cart mutation. When the base
        // product changes (e.g. the first line item is removed) requestKey changes
        // and it fetches fresh below.
        if (requestKey === cartUpsellCache.key && cartUpsellCache.html) {
          html = cartUpsellCache.html;
        } else {
          try {
            this._abortController?.abort?.();
          } catch (e) { }
          this._abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

          const response = await fetch(url, {
            method: 'GET',
            signal: this._abortController ? this._abortController.signal : undefined,
          });
          html = await response.text();
          if (html.trim()) cartUpsellCache = { key: requestKey, html };
        }

        if (!html.trim()) {
          this.style.display = 'none';
          return;
        }

        this.innerHTML = html;
        this.initialized = true;
        this.style.display = '';

        const sectionRoot = this.querySelector('.cart-drawer-upsell');
        if (!sectionRoot) {
          this.style.display = 'none';
          return;
        }

        try {
          const swiperEl = this.querySelector('[data-upsell-swiper]');
          if (swiperEl) {
            // Swiper is no longer a sitewide bundle — pull it in on demand the
            // first time the upsell actually renders.
            const initUpsell = (Swiper) => {
              if (!Swiper || !swiperEl.isConnected) return;
              const nextEl = this.querySelector('[data-upsell-next]');
              const prevEl = this.querySelector('[data-upsell-prev]');
              const scrollbarEl = this.querySelector('[data-upsell-scrollbar]');
              if (this._swiper && typeof this._swiper.destroy === 'function') {
                this._swiper.destroy(true, true);
              }
              this._swiper = new Swiper(swiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                freeMode: true,
                watchOverflow: true,
                navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
                scrollbar: scrollbarEl ? { el: scrollbarEl, draggable: true } : undefined,
              });
            };
            if (window.Swiper) {
              initUpsell(window.Swiper);
            } else if (window.__mnLoadSwiper) {
              window.__mnLoadSwiper().then(initUpsell).catch(() => {});
            }
          }
        } catch (e) {
          console.error('Failed to init Swiper for upsell', e);
        }

        bindFrequentlyBoughtWithUpsellTracking(sectionRoot, this._swiper);

        sectionRoot.addEventListener('change', (event) => {
          const selectEl = event.target.closest('[data-upsell-variant-select]');
          if (!selectEl) return;

          const itemEl = selectEl.closest('.cart-drawer-upsell-item');
          const errEl = itemEl?.querySelector('[data-upsell-variant-error]');
          if (errEl) {
            errEl.hidden = true;
            errEl.textContent = '';
          }
          selectEl.removeAttribute('aria-invalid');

          const selectedVariantId = Number(selectEl.value || '0');
          if (!selectedVariantId) return;

          let variants = [];
          try {
            if (!selectEl._upsellVariantsCache) {
              const raw = selectEl.getAttribute('data-variants') || '[]';
              selectEl._upsellVariantsCache = JSON.parse(raw);
            }
            variants = Array.isArray(selectEl._upsellVariantsCache)
              ? selectEl._upsellVariantsCache
              : [];
          } catch (e) {
            variants = [];
          }

          const variant = variants.find((v) => Number(v?.id) === selectedVariantId);
          if (!variant) return;

          trackUpsellEvent(
            'upsell_variant_selected',
            buildUpsellPayload(UPSELL_SOURCE.FBW, itemEl, {
              variant_id: selectedVariantId,
              variant_title: variant.title || variant.public_title || '',
              price: Number(variant.price) || 0,
              compare_at_price: Number(variant.compare_at_price) || 0,
            }),
          );

          const priceCents = Number(variant.price || 0);
          const compareAtCents = Number(variant.compare_at_price || 0);
          const price = formatMoney(priceCents);
          const compareAt =
            compareAtCents > priceCents ? formatMoney(compareAtCents) : '';
          const discountBadge =
            compareAtCents > priceCents
              ? `SAVE ${Math.round(((compareAtCents - priceCents) * 100) / compareAtCents)}%`
              : '';

          if (!itemEl) return;

          const priceRow = itemEl.querySelector('.cart-drawer-upsell-item__price-row');
          if (!priceRow) return;

          if (compareAt && compareAt !== '') {
            priceRow.innerHTML = `
            <span class="cart-drawer-upsell-item__price-original">${compareAt}</span>
            <span class="cart-drawer-upsell-item__price-current">${price}</span>
            <span class="cart-drawer-upsell-item__badge">${discountBadge}</span>
          `;
          } else {
            priceRow.innerHTML = `
            <span class="cart-drawer-upsell-item__price-current">${price}</span>
          `;
          }
        });

        sectionRoot.addEventListener('click', async (event) => {
          const btn = event.target.closest('[data-upsell-add]');
          if (!btn) return;
          const itemEl = btn.closest('.cart-drawer-upsell-item');
          if (!itemEl) return;
          const selectEl = itemEl.querySelector('[data-upsell-variant-select]');
          if (selectEl) {
            const raw = (selectEl.value || '').trim();
            if (!raw) {
              const errEl = itemEl.querySelector('[data-upsell-variant-error]');
              const msg =
                (itemEl.dataset.upsellChooseSizeError || '').trim() || 'Choose a size.';
              if (errEl) {
                errEl.textContent = msg;
                errEl.hidden = false;
              }
              selectEl.setAttribute('aria-invalid', 'true');
              selectEl.focus();
              trackUpsellEvent(
                'upsell_add_failed',
                buildUpsellPayload(UPSELL_SOURCE.FBW, itemEl, getFbUpsellVariantData(selectEl, itemEl) || {}, {
                  reason: 'missing_variant',
                }),
              );
              return;
            }
            selectEl.removeAttribute('aria-invalid');
            const errClear = itemEl.querySelector('[data-upsell-variant-error]');
            if (errClear) {
              errClear.hidden = true;
              errClear.textContent = '';
            }
          }
          const variantId = Number(selectEl ? selectEl.value : itemEl.dataset.variantId || '0');
          if (!variantId) return;

          const variantData = getFbUpsellVariantData(selectEl, itemEl);
          const cartValueBefore = getCartTotalValue(window.cartJSON);

          try {
            setCartDrawerLoading(true);
            btn.disabled = true;
            const json = await fetch(this.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }],
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname,
              }),
            }).then((r) => r.json());

            if (json?.status) {
              trackUpsellEvent(
                'upsell_add_failed',
                buildUpsellPayload(UPSELL_SOURCE.FBW, itemEl, variantData || {}, {
                  reason: 'sold_out',
                }),
              );
              return;
            }

            // cart/add.js might not return full cart JSON; render sections now and refresh cart state once.
            handleCartApiResponse(json, { skipExclusivePanel: true });

            let cartAfter = null;
            if (typeof window.refreshCartFromServer === 'function') {
              cartAfter = await window.refreshCartFromServer();
            }

            const cartValueAfter =
              getCartTotalValue(cartAfter) ??
              getCartTotalValue(json) ??
              getCartTotalValue(window.cartJSON);

            trackUpsellEvent(
              'upsell_add_to_cart',
              buildUpsellPayload(UPSELL_SOURCE.FBW, itemEl, variantData || {}, {
                cart_value_before: cartValueBefore,
                cart_value_after: cartValueAfter,
              }),
            );
          } catch (e) {
            console.error('Failed to add upsell item', e);
            trackUpsellEvent(
              'upsell_add_failed',
              buildUpsellPayload(UPSELL_SOURCE.FBW, itemEl, variantData || {}, {
                reason: 'fetch_error',
              }),
            );
          } finally {
            btn.disabled = false;
            setCartDrawerLoading(false);
          }
        });
      } finally {
        this._loading = false;
      }
    } catch (e) {
      this._loading = false;
      console.error('CartDrawerUpsell error', e);
      this.style.display = 'none';
    }
  }
}

customElements.define('cart-drawer-upsell', CartDrawerUpsell);

/* ========== Exclusive Cart Panel ========== */
(function initExclusivePanel() {
  const panel = document.getElementById('CartDrawer-Exclusive');
  if (!panel) return;

  bindExclusivePanelUpsellTracking(panel);

  // Close buttons (header X and sticky "No Thanks")
  panel.querySelectorAll('[data-exclusive-close]').forEach((closeBtn) => {
    closeBtn.addEventListener('click', () => {
      panel.classList.add('is-closed');
      try { sessionStorage.setItem('exclusive_panel_dismissed', '1'); } catch (e) { }
      trackUpsellEvent('upsell_dismissed', {
        source: UPSELL_SOURCE.EXCLUSIVE,
        ...getUpsellTrackingContext(),
      });
    });
  });

  // Variant select → update price + button variant id
  panel.querySelectorAll('[data-exclusive-variant-select]').forEach((select) => {
    const item = select.closest('.cart-drawer-exclusive-item');
    if (!item) return;
    const addBtn = item.querySelector('[data-exclusive-add]');
    const priceRow = item.querySelector('.cart-drawer-exclusive-item__price-row');

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option || !option.value) return;

      // Clear error state
      select.classList.remove('cart-drawer-exclusive-item__select--error');
      const err = item.querySelector('.cart-drawer-exclusive-item__variant-error');
      if (err) err.hidden = true;

      if (addBtn) addBtn.dataset.variantId = option.value;

      trackUpsellEvent(
        'upsell_variant_selected',
        buildUpsellPayload(UPSELL_SOURCE.EXCLUSIVE, item, {
          variant_id: Number(option.value),
          variant_title: option.textContent?.trim() || '',
          price: Number(option.dataset.price) || 0,
          compare_at_price: Number(option.dataset.compareAt) || 0,
        }),
      );

      // Update price display
      if (priceRow) {
        const price = Number(option.dataset.price || 0);
        const compareAt = Number(option.dataset.compareAt || 0);

        if (compareAt > price && compareAt > 0) {
          const discount = Math.round(((compareAt - price) / compareAt) * 100);
          priceRow.innerHTML = `
            <span class="cart-drawer-exclusive-item__price-current">${formatMoney(price)}</span>
            <span class="cart-drawer-exclusive-item__price-original">${formatMoney(compareAt)}</span>
            <span class="cart-drawer-exclusive-item__badge">SAVE ${discount}%</span>
          `;
        } else {
          priceRow.innerHTML = `
            <span class="cart-drawer-exclusive-item__price-current">${formatMoney(price)}</span>
          `;
        }
      }
    });
  });

  // Add to cart buttons
  panel.querySelectorAll('[data-exclusive-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const item = btn.closest('.cart-drawer-exclusive-item');
      const select = item ? item.querySelector('[data-exclusive-variant-select]') : null;

      // Validate: if select exists but nothing chosen
      if (select && !select.value) {
        select.classList.add('cart-drawer-exclusive-item__select--error');
        let errorEl = item.querySelector('.cart-drawer-exclusive-item__variant-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'cart-drawer-exclusive-item__variant-error';
          select.insertAdjacentElement('afterend', errorEl);
        }
        errorEl.textContent = 'Please select an option.';
        errorEl.hidden = false;
        trackUpsellEvent(
          'upsell_add_failed',
          buildUpsellPayload(UPSELL_SOURCE.EXCLUSIVE, item, {}, { reason: 'missing_variant' }),
        );
        setTimeout(() => {
          select.classList.remove('cart-drawer-exclusive-item__select--error');
        }, 2000);
        return;
      }

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const variantData = getExclusiveUpsellVariantData(select, item, btn);
      const cartValueBefore = getCartTotalValue(window.cartJSON);

      // Clear any previous error
      if (select) {
        select.classList.remove('cart-drawer-exclusive-item__select--error');
        const err = item.querySelector('.cart-drawer-exclusive-item__variant-error');
        if (err) err.hidden = true;
      }

      const originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;
      let added = false;

      try {
        setCartDrawerLoading(true);

        const addJson = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        }).then((r) => r.json());

        if (addJson?.status) {
          trackUpsellEvent(
            'upsell_add_failed',
            buildUpsellPayload(UPSELL_SOURCE.EXCLUSIVE, item, variantData || {}, {
              reason: 'sold_out',
            }),
          );
          const failDrawer = document.querySelector('cart-drawer');
          if (failDrawer && typeof failDrawer.showToast === 'function') {
            failDrawer.showToast(addJson.description || 'Unable to add this item to your cart.');
          }
          return;
        }
        added = true;

        const cartAfter = await window.refreshCartFromServer();

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          const data = await fetch('/?sections=cart-drawer,cart-icon-bubble', { method: 'GET' }).then((r) => r.json());
          cartDrawer.renderContents({ sections: data }, true, { skipExclusivePanel: true });
        }

        const cartValueAfter =
          getCartTotalValue(cartAfter) ??
          getCartTotalValue(addJson) ??
          getCartTotalValue(window.cartJSON);

        trackUpsellEvent(
          'upsell_add_to_cart',
          buildUpsellPayload(UPSELL_SOURCE.EXCLUSIVE, item, variantData || {}, {
            cart_value_before: cartValueBefore,
            cart_value_after: cartValueAfter,
          }),
        );
      } catch (e) {
        console.error('Failed to add exclusive item', e);
        trackUpsellEvent(
          'upsell_add_failed',
          buildUpsellPayload(UPSELL_SOURCE.EXCLUSIVE, item, variantData || {}, {
            reason: 'fetch_error',
          }),
        );
      } finally {
        btn.textContent = added ? 'ADDED ✓' : originalText;
        btn.disabled = false;
        setCartDrawerLoading(false);
        if (added) {
          setTimeout(() => {
            btn.textContent = originalText;
          }, 1500);
        }
      }
    });
  });
})();
